import 'react-toastify/dist/ReactToastify.min.css';

import PropTypes from 'prop-types';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';

import { LoadingPage } from './scenes/LoadingPage/LoadingPage';
import { MountActionsGate } from './wrappers/MountActionsGate';
import { MuiThemeProvider } from './wrappers/MuiThemeProvider/MuiThemeProvider';

const AppWrapper = ({
    children, store, persistor, mountActions, setupIntl, withEssentialReload,
}) => (
    <MuiThemeProvider>
        <Provider store={store}>
            <PersistGate loading={<LoadingPage />} persistor={persistor}>
                <MountActionsGate
                    actions={mountActions}
                    setupIntl={setupIntl}
                    withEssentialReload={withEssentialReload}
                >
                    <IntlProvider {...store.getState().i18n}>
                        <div style={{ height: '100%' }}>
                            {children}
                            <ToastContainer autoClose={8000} position="bottom-right" />
                        </div>
                    </IntlProvider>
                </MountActionsGate>
            </PersistGate>
        </Provider>
    </MuiThemeProvider>
);

AppWrapper.propTypes = {
    store: PropTypes.any.isRequired,
    persistor: PropTypes.any.isRequired,
    children: PropTypes.node.isRequired,

    /** Array of Promises to execute on mount */
    mountActions: PropTypes.arrayOf(PropTypes.func),
    /**
     * Automatically setup react-intl & intl
     * This does NOT setup the messages, only the locales & 'intl', if it needs to be imported
     */
    setupIntl: PropTypes.bool,

    /** If should trigger 'BaseActions.triggerEssentialReload' */
    withEssentialReload: PropTypes.bool,
};

AppWrapper.defaultProps = {
    mountActions: [],

    setupIntl: false,
    withEssentialReload: false,
};

export { AppWrapper };
